// dependencies
import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

// utils
import get from "../../utils/GetNested";
import serializeObject from "../../utils/SerializeObject";

export const fetchTemplate = CreateProcess({
	method: "GET",
	name: "FetchTemplate",
	type: "REVIEWCYCLES:GETTEMPLATE",

	request: (props) => {
		const queryParams = serializeObject(props.params || {});
		return {
			url: `/api/review-templates/${props.templateID}/?${queryParams}`,
		};
	},

	success: (response) => fromJS(response.data),
});

export const createTemplate = CreateProcess({
	method: "POST",
	name: "CreateTemplate",
	type: "REVIEWCYCLES:CREATETEMPLATE",

	request: (props) => ({
		url: "/api/review-templates/",
		payload: props.payload,
	}),

	success: (response) => response.data,
});

export const editTemplate = CreateProcess({
	method: "POST",
	name: "EditTemplate",
	type: "REVIEWCYCLES:EDITTEMPLATE",

	request: (props) => ({
		url: `/api/review-templates/${props.templateID}`,
		payload: props.payload,
	}),

	success: (response) => response.data,
});

export const deleteTemplate = CreateProcess({
	method: "DELETE",
	name: "DeleteTemplate",
	type: "REVIEWCYCLES:DELETETEMPLATE",

	request: (props) => ({
		url: `/api/review-templates/${props.templateID}`,
	}),

	success: (response) => response.data,
});

export const fetchBulkTemplates = CreateProcess({
	method: "POST",
	name: "FetchBulkTemplates",
	type: "REVIEWS:GETBULKTEMPLATES",

	request: (props) => {
		const payload = get(props, ["params", "payload"], props.payload);
		const offset = get(props, ["params", "offset"], props.offset) || "";
		const url = offset
			? `/micro/v0.1/review-template-picker/?offset=${offset}`
			: "/micro/v0.1/review-template-picker";

		return {
			url,
			payload,
		};
	},

	success: (response) => response.data,
});
